import React from 'react';
import {
    change as changeFieldValue, Field, formValueSelector, reduxForm,
} from 'redux-form';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import {
    maxValueMonetario,
    minValueMonetario,
    renderFieldCheck,
    renderFieldMonetarioFormulario,
    renderFieldNumerosPorcentagem,
    renderFieldText, required, tamanhoPorcentagem,
} from '../../util/inputs';
import {arredondamentoPadrao, realParaNumber} from '../../util/numberUtil';
import {adicionarFormasPagamento} from '../../actions/viagem/adicionarFormasPagamento';

export const validate = (values, props) => {
    const errors = {};

    const checkMaxValue = (field, max, message) => {
        if (values[field] && Number(values[field]) > Number(max)) {
            errors[field] = message;
        }
    };

    // Verificações para garantir que os objetos viagemIda e viagemVolta existam
    if (props.viagemIda) {
        checkMaxValue('descontoIda', props.viagemIda.descontoMaximoUsuarioRota, `Desconto máximo permitido é ${props.viagemIda.descontoMaximoUsuarioRota} %`);
        checkMaxValue('acrescimoPassagemIda', props.viagemIda.acrescimoMaximoPassagem, `Acréscimo máximo passagem é ${props.viagemIda.acrescimoMaximoPassagem} %`);
    }

    if (props.viagemVolta) {
        checkMaxValue('descontoVolta', props.viagemVolta.descontoMaximoUsuarioRota, `Desconto máximo permitido é ${props.viagemVolta.descontoMaximoUsuarioRota} %`);
        checkMaxValue('acrescimoPassagemVolta', props.viagemVolta.acrescimoMaximoPassagem, `Acréscimo máximo passagem é ${props.viagemVolta.acrescimoMaximoPassagem} %`);
    }

    const validateTotal = (fields) => {
        const valorTotal = arredondamentoPadrao(fields.reduce((acc, field) => acc + realParaNumber(values[field]), 0));
        if (valorTotal !== props.totalReserva) {
            fields.forEach(field => {
                errors[field] = 'A soma dos valores deve ser igual ao valor total';
            });
        }
    };

    // Verificar se pelo menos um checkbox está marcado
    const checkboxes = ['cartaoCredito', 'cartaoDebito', 'dinheiro', 'pix'];
    const anyCheckboxChecked = checkboxes.some(field => values[field]);

    if (!anyCheckboxChecked) {
        errors.pagamento = 'Pelo menos uma opção de pagamento deve ser selecionada';
    }

    if (values.cartaoCredito && values.pix && values.dinheiro) {
        validateTotal(['valorCartaoCredito', 'valorPIX', 'valorDinheiro']);
    } else if (values.cartaoDebito && values.pix && values.dinheiro) {
        validateTotal(['valorCartaoDebito', 'valorPIX', 'valorDinheiro']);
    } else if (values.cartaoCredito && values.dinheiro) {
        validateTotal(['valorCartaoCredito', 'valorDinheiro']);
    } else if (values.cartaoDebito && values.dinheiro) {
        validateTotal(['valorCartaoDebito', 'valorDinheiro']);
    } else if (values.pix && values.dinheiro) {
        validateTotal(['valorPIX', 'valorDinheiro']);
    } else if (values.pix && values.cartaoCredito) {
        validateTotal(['valorPIX', 'valorCartaoCredito']);
    } else if (values.pix && values.cartaoDebito) {
        validateTotal(['valorPIX', 'valorCartaoDebito']);
        // eslint-disable-next-line no-dupe-else-if
    } else if (values.cartaoCredito && values.cartaoDebito && values.dinheiro && values.pix) {
        validateTotal(['valorCartaoCredito', 'valorCartaoDebito', 'valorPIX', 'valorDinheiro']);
        // eslint-disable-next-line no-dupe-else-if
    } else if (values.cartaoCredito && values.cartaoDebito && values.dinheiro) {
        validateTotal(['valorCartaoCredito', 'valorCartaoDebito', 'valorDinheiro']);
    } else if (values.cartaoCredito && values.cartaoDebito) {
        validateTotal(['valorCartaoCredito', 'valorCartaoDebito']);
    } else if (values.cartaoCredito) {
        if (realParaNumber(values.valorCartaoCredito) !== props.totalReserva) {
            errors.valorCartaoCredito = 'Valor deve ser igual ao valor total';
        }
        if (values.quantidadeParcelas && !values.quantidadeParcelas.match(/^[0-9]+$/)) {
            errors.quantidadeParcelas = 'Valor deve ser um número inteiro';
        }
    } else if (values.cartaoDebito) {
        if (realParaNumber(values.valorCartaoDebito) !== props.totalReserva) {
            errors.valorCartaoDebito = 'Valor deve ser igual ao valor total';
        }
    } else if (values.pix) {
        if (realParaNumber(values.valorPIX) !== props.totalReserva) {
            errors.valorPIX = 'Valor deve ser igual ao valor total';
        }
    } else if (values.dinheiro) {
        if (realParaNumber(values.valorDinheiro) !== props.totalReserva) {
            errors.valorDinheiro = 'Valor deve ser igual ao valor total';
        }
    }

    return errors;
};


export class FormCadastrarFormaPagamento extends React.Component {

    componentDidMount() {
        const pagamentos = []
        pagamentos.push({
            tipo: 'Dinheiro',
            base64Comprovante: '',
            numeroComprovante: '',
            valor: this.props.valorDinheiro,
            quantidadeParcelas: 1,
        });
        this.props.adicionarFormasPagamento(pagamentos);
    }

    handleChange(event) {
        const file = event.target.files[0];
        if (/\.(jpe?g|png|pdf)$/i.test(file.name) === false) {
            return
        }
        this.converterParaBase64(file, 'CARTAO')
    }


    handleChangePix(event) {
        const file = event.target.files[0];
        if (/\.(jpe?g|png|pdf)$/i.test(file.name) === false) {
            return
        }
        this.converterParaBase64(file, 'PIX')
    }

    converterParaBase64(file, formaPagamento) {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = function () {
            if (formaPagamento == 'PIX') {
                this.props.changeFieldValue('formReserva',
                    'base64ComprovantePIX', reader.result);
                this.props.changeFieldValue('formReserva',
                    'nomeComprovanteVendaPIX', file.name);
            } else {
                this.props.changeFieldValue('formReserva',
                    'base64Comprovante', reader.result);
                this.props.changeFieldValue('formReserva',
                    'nomeComprovanteVenda', file.name);
            }
        }.bind(this);
    }

    limparFormulario() {
        this.props.reset('formReserva');
        this.removerArquivo();
    }

    exibirAnexoCartao() {        
        const r = this.props.cartaoCredito || this.props.cartaoDebito
        return r;
    }

    exibirAnexar() {
        if (this.props.base64Comprovante) {
            return (
                <div className="row align-items-center mt-2">
                    <div className='col-12 label-cancelamento'>
                        <label>Comprovante:</label>
                    </div>
                    <div className='ml-4'>{this.props.nomeComprovanteVenda}</div>
                    {this.exibirRemoverComprovante('CARTAO')}
                </div>)
        }
        return (
            <div className='input-wrapper mt-3'>
                <label className='btn-laranja' htmlFor='input-file'>
                    <div className='row align-items-center'>
                        <i className="material-icons aberto">&#xe2c3;</i>
                        <strong className='ml-2'>Anexar comprovante de pagamento</strong>
                    </div>
                </label>
                <input id='input-file' type='file' value='' accept="image/png,image/jpeg,application/pdf"
                       onChange={this.handleChange.bind(this)}/>
            </div>)
    }

    exibirAnexarPix() {
        if (this.props.base64ComprovantePIX) {
            return (
                <div className="row align-items-center mt-2">
                    <div className='col-12 label-cancelamento'>
                        <label>Comprovante:</label>
                    </div>
                    <div className='ml-4'>{this.props.nomeComprovanteVendaPIX}</div>
                    {this.exibirRemoverComprovante('PIX')}
                </div>)
        }
        return (
            <div className='input-wrapper mt-3'>
                <label className='btn-laranja' htmlFor='input-file'>
                    <div className='row align-items-center'>
                        <i className="material-icons aberto">&#xe2c3;</i>
                        <strong className='ml-2'>Anexar comprovante de pagamento</strong>
                    </div>
                </label>
                <input id='input-file' type='file' value='' accept="image/png,image/jpeg,application/pdf"
                       onChange={this.handleChangePix.bind(this)}/>
            </div>)
    }

    exibirRemoverComprovante(formaPagamento) {
        return (
            <button type="button" className="btn btn-editar"
                    title='Remover'
                    onClick={() => this.removerArquivo(formaPagamento)}>
                <i className="material-icons nav-icon" style={{
                    color: 'red',
                }}>&#xe14c;</i>
            </button>)
    }

    removerArquivo(formaPagamento) {
        if (formaPagamento == 'PIX') {
            this.props.changeFieldValue('formReserva',
                'base64ComprovantePIX', null);
            this.props.changeFieldValue('formReserva',
                'nomeComprovanteVendaPIX', null);
        } else {
            this.props.changeFieldValue('formReserva',
                'base64Comprovante', null);
            this.props.changeFieldValue('formReserva',
                'nomeComprovanteVenda', null);
        }
    }

    handleCheckDinheiro() {
        const dinheiro = !this.props.dinheiro;
        this.props.changeFieldValue('formReserva',
            'dinheiro', dinheiro);

        this.props.changeFieldValue('formReserva',
            'valorDinheiro', this.props.totalReserva.toLocaleString('pt-br', {style: 'currency', currency: 'BRL'}));

        this.props.verificarSeFormaPagamentoNaoFoiSelecionado(dinheiro, this.props.cartaoCredito, this.props.cartaoDebito, this.props.pix);
    }


    handleCheckCartaoCredito() {
        const cartaoCredito = !this.props.cartaoCredito;
        this.props.changeFieldValue('formReserva', 'cartaoCredito', cartaoCredito);

        this.props.changeFieldValue('formReserva',
            'valorCartaoCredito', this.props.totalReserva.toLocaleString('pt-br', {style: 'currency', currency: 'BRL'}));

        this.props.verificarSeFormaPagamentoNaoFoiSelecionado(this.props.dinheiro, this.props.cartaoCredito, this.props.cartaoDebito, this.props.pix);
    }

    handleCheckCartaoDebito() {
        const cartaoDebito = !this.props.cartaoDebito;
        this.props.changeFieldValue('formReserva', 'cartaoDebito', cartaoDebito);

        this.props.changeFieldValue('formReserva',
            'valorCartaoDebito', this.props.totalReserva.toLocaleString('pt-br', {style: 'currency', currency: 'BRL'}));

        this.props.verificarSeFormaPagamentoNaoFoiSelecionado(this.props.dinheiro, this.props.cartaoCredito, this.props.cartaoDebito, this.props.pix);
    }

    handleCheckPix() {
        const pix = !this.props.pix;
        this.props.changeFieldValue('formReserva',
            'pix', pix);

        this.props.changeFieldValue('formReserva',
                'valorPIX', this.props.totalReserva.toLocaleString('pt-br', {style: 'currency', currency: 'BRL'}));

        this.props.verificarSeFormaPagamentoNaoFoiSelecionado(this.props.dinheiro, this.props.cartaoCredito, pix);
    }

    handleAcrescimoPassagemIda(e) {
        this.props.calcularAcrescimoPassagemUsuarioIda(e.target.value);
        if (e.target.value) {
            this.props.habilitaOuDesabilitaDescontoUsuarioIda(false);
            this.props.habilitaOuDesabilitaAcrescimoPassagemIda(true);
        } else {
            this.props.habilitaOuDesabilitaAcrescimoPassagemIda(true);
            this.props.habilitaOuDesabilitaDescontoUsuarioIda(true);
        }
    }

    handleDescontoIda(e) {
        this.props.calcularDescontoUsuarioRotaIda(e.target.value)
        if (e.target.value) {
            this.props.habilitaOuDesabilitaDescontoUsuarioIda(true);
            this.props.habilitaOuDesabilitaAcrescimoPassagemIda(false);
        } else {
            this.props.habilitaOuDesabilitaAcrescimoPassagemIda(true);
            this.props.habilitaOuDesabilitaDescontoUsuarioIda(true);
        }
    }

    handleDescontoVolta(e) {
        this.props.calcularDescontoUsuarioRotaVolta(e.target.value)
        if (e.target.value) {
            this.props.habilitaOuDesabilitaDescontoUsuarioVolta(true);
            this.props.habilitaOuDesabilitaAcrescimoPassagemVolta(false);
        } else {
            this.props.habilitaOuDesabilitaAcrescimoPassagemVolta(true);
            this.props.habilitaOuDesabilitaDescontoUsuarioVolta(true);
        }
    }

    handleAcrescimoPassagemVolta(e) {
        this.props.calcularAcrescimoPassagemUsuarioVolta(e.target.value)
        if (e.target.value) {
            this.props.habilitaOuDesabilitaDescontoUsuarioVolta(false);
            this.props.habilitaOuDesabilitaAcrescimoPassagemVolta(true);
        } else {
            this.props.habilitaOuDesabilitaAcrescimoPassagemVolta(true);
            this.props.habilitaOuDesabilitaDescontoUsuarioVolta(true);
        }
    }

    render() {
        return (
            <div>
                <div>
                    <form>
                        <div className="modal-body">
                            <div className="form-check form-check-inline d-flex justify-content-center">
                                <Field name="cartaoCredito" type="checkbox" component={renderFieldCheck}
                                       label="Cartão de Crédito"
                                       css="form-check-input" readOnly={false} className="form-check-input"
                                       onChange={() => this.handleCheckCartaoCredito()}/>
                                <Field name="cartaoDebito" type="checkbox" component={renderFieldCheck}
                                       label="Cartão de Débito"
                                       css="form-check-input" readOnly={false} className="form-check-input"
                                       onChange={() => this.handleCheckCartaoDebito()}/>
                                <Field name="dinheiro" type="checkbox" component={renderFieldCheck} label="Dinheiro"
                                       css="form-check-input" readOnly={false} className="form-check-input"
                                       onChange={() => this.handleCheckDinheiro()}/>
                                <Field name="pix" type="checkbox" component={renderFieldCheck} label="PIX"
                                       css="form-check-input" readOnly={false} className="form-check-input"
                                       onChange={() => this.handleCheckPix()}/>
                            </div>
                            <div className="d-flex justify-content-center">
                                <div>
                                    <div className="form-row">
                                        {this.props.dinheiro ? <div className="form-group">
                                                <Field name="valorDinheiro" type="text"
                                                       validate={[required, maxValueMonetario, minValueMonetario]}
                                                       component={renderFieldMonetarioFormulario}
                                                       css="form-control col-md-10" label="Valor em dinheiro"/>
                                            </div>
                                            : ''}
                                    </div>
                                    {this.props.cartaoCredito && <div className="form-row">
                                        <h4><strong>Informações pagamento com cartão de crédito</strong></h4>
                                    </div>}
                                    {this.props.cartaoCredito ? <div className="form-row">
                                        <div className="form-group">
                                            <Field name="valorCartaoCredito" type="text"
                                                   validate={[required, maxValueMonetario, minValueMonetario]}
                                                   component={renderFieldMonetarioFormulario}
                                                   css="form-control col-md-8" label="Valor em cartão de crédito"/>
                                        </div>
                                        <div className="form-group">
                                            <Field name="numeroComprovanteCredito" type="text"
                                                   component={renderFieldText}
                                                   css="form-control col-md-8" label="Número comprovante crédito:"/>
                                        </div>
                                    </div> : ''}
                                    {this.props.cartaoDebito && <div className="form-row">
                                        <h4><strong>Informações pagamento com cartão de débito</strong></h4>
                                    </div>}
                                    {this.props.cartaoDebito ? <div className="form-row">
                                        <div className="form-group">
                                            <Field name="valorCartaoDebito" type="text"
                                                   validate={[required, maxValueMonetario, minValueMonetario]}
                                                   component={renderFieldMonetarioFormulario}
                                                   css="form-control col-md-8" label="Valor em cartão de débito"/>
                                        </div>
                                        <div className="form-group">
                                            <Field name="numeroComprovanteDebito" type="text"
                                                   component={renderFieldText}
                                                   css="form-control col-md-8" label="Número comprovante débito:"/>
                                        </div>
                                    </div> : ''}
                                    {this.props.pix && <div className="form-row">
                                        <h4><strong>Informações pagamento com PIX</strong></h4>
                                    </div>}
                                    {this.props.pix ? <div className="form-row">
                                        <div className="form-group">
                                            <Field name="valorPIX" type="text"
                                                   validate={[required, maxValueMonetario, minValueMonetario]}
                                                   component={renderFieldMonetarioFormulario}
                                                   css="form-control col-md-8" label="Valor em PIX" />
                                        </div>
                                        <div className="form-group">
                                            <Field name="numeroComprovantePIX" type="text" component={renderFieldText}
                                                   css="form-control col-md-8" label="Número comprovante PIX:" />
                                        </div>
                                    </div> : ''}
                                    {this.props.pix && <div className='form-row'>
                                        <div className="form-group">
                                            {this.exibirAnexarPix()}
                                        </div>
                                    </div>}
                                    {(this.exibirAnexoCartao()) && <div className='form-row'>
                                        <div className="form-group">
                                            {this.exibirAnexar()}
                                        </div>
                                    </div>}
                                    <div className='form-row'>
                                        {this.props.habilitadoAcrescimoPassagemIda && this.props.permiteAcrescimoMaxmoUsuarioIda() && !this.props.ehRemarcacao ?
                                            <div className='form-group mr-2'>
                                                <Field name='acrescimoPassagemIda'
                                                       validate={[tamanhoPorcentagem]}
                                                       component={renderFieldNumerosPorcentagem}
                                                       onBlur={(e) => this.handleAcrescimoPassagemIda(e)}
                                                       css="form-control col-md-6" label="Acréscimo máximo Passagem ida (%)" />
                                            </div>
                                            :''}
                                        {this.props.habilitadoAcrescimoPassagemVolta && this.props.permiteAcrescimoMaximoUsuarioVolta()  && !this.props.ehRemarcacao ?
                                            <div className='form-group mr-2'>
                                                <Field name='acrescimoPassagemVolta'
                                                       validate={[tamanhoPorcentagem]}
                                                       component={renderFieldNumerosPorcentagem}
                                                       onBlur={(e) => this.handleAcrescimoPassagemVolta(e)}
                                                       css="form-control col-md-6" label="Acréscimo máximo Passagem volta (%)" />
                                            </div>
                                            :''}
                                    </div>
                                    <div className='form-row'>
                                        {this.props.habilitadoDescontoUsuarioIda && this.props.permiteDescontoUsuarioRotaIda() && !this.props.ehRemarcacao?
                                            <div className='form-group mr-2'>
                                                <Field name='descontoIda'
                                                       validate={[tamanhoPorcentagem]}
                                                       component={renderFieldNumerosPorcentagem}
                                                       onBlur={(e) => this.handleDescontoIda(e)}
                                                       css="form-control col-md-6" label="Desconto máximo para rota ida (%)" />
                                            </div>
                                            : ''}
                                        {this.props.habilitadoDescontoUsuarioVolta && this.props.permiteDescontoUsuarioRotaVolta() && !this.props.ehRemarcacao?
                                            <div className='form-group'>
                                                <Field name='descontoVolta'
                                                       validate={[tamanhoPorcentagem]}
                                                       component={renderFieldNumerosPorcentagem}
                                                       onBlur={(e) => this.handleDescontoVolta(e)}
                                                       css="form-control col-md-6" label="Desconto máximo para rota volta (%)" />
                                            </div>
                                            : ''}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        );
    }
}

const seletor = formValueSelector('formReserva');

export function mapStateToProps(state) {
    return {
        viagemIda: state.viagemIda,
        viagemVolta: state.viagemVolta,
        passageirosIda: state.passageirosIda,
        passageirosVolta: state.passageirosVolta,
        nomeComprovanteVenda: seletor(state, 'nomeComprovanteVenda'),
        numeroComprovante: seletor(state, 'numeroComprovante'),
        base64Comprovante: seletor(state, 'base64Comprovante'),
        nomeComprovanteVendaPIX: seletor(state, 'nomeComprovanteVendaPIX'),
        numeroComprovantePIX: seletor(state, 'numeroComprovantePIX'),
        base64ComprovantePIX: seletor(state, 'base64ComprovantePIX'),
        dinheiro: seletor(state, 'dinheiro'),
        cartao: seletor(state, 'cartao'),
        cartaoCredito: seletor(state, 'cartaoCredito'),
        cartaoDebito: seletor(state, 'cartaoDebito'),
        pix: seletor(state, 'pix'),
        descontoIda: seletor(state, 'descontoIda'),
        descontoVolta: seletor(state, 'descontoVolta'),
        acrescimoPassagemIda: seletor(state, 'acrescimoPassagemIda'),
        acrescimoPassagemVolta: seletor(state, 'acrescimoPassagemVolta'),
        valorCartao: seletor(state, 'valorCartao'),
        valorCartaoCredito: seletor(state, 'valorCartaoCredito'),
        valorCartaoDebito: seletor(state, 'valorCartaoDebito'),
        valorDinheiro: seletor(state, 'valorDinheiro'),
        valorPIX: seletor(state, 'valorPIX'),
        quantidadeParcelas: Number(seletor(state, 'quantidadeParcelas')),
    }
}

export const mapDispatchToProps = dispatch => (
    bindActionCreators({
        changeFieldValue,
        adicionarFormasPagamento,
    }, dispatch)
);

export default connect(mapStateToProps, mapDispatchToProps)(reduxForm({
    form: 'formReserva',
    enableReinitialize: true,
    destroyOnUnmount: false,
    forceUnregisterOnUnmount: true,
    validate,
})(FormCadastrarFormaPagamento));
